import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService, WorkshoppingService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss'],
  providers: [WorkshoppingService]
})
export class UserLoginComponent implements OnInit {
  @Output() fin = new EventEmitter<boolean>();
  @Input() conf: any
  proccess: Boolean;
  user: string;
  pass: string;

  showPass = false;
  // llamado desde el template
  onTogglePass(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation(); // evita que el form capture click
    console.log('togglePass clickeado'); // debug
    this.showPass = !this.showPass;

    // opcional: mantener focus en el campo después de click
    const el = (event.currentTarget as HTMLElement).closest('.input-group')?.querySelector('input');
    if (el) { (el as HTMLElement).focus(); }
  }
  togglePass() {
    console.log("sssssss")
    this.showPass = !this.showPass;
  }

  constructor(private wsdlu: UsuarioService,
    private route: Router,
    private wsdl: WorkshoppingService,

  ) { }

  ngOnInit() {
  }

  async login() {

    try {

      this.proccess = true;
      let data = await this.wsdlu.doLogin({ usuario: this.user, clave: this.pass }).then();
      let res = JSON.parse(JSON.stringify(data));

      if (res.code == 200) {

        UturuncoUtils.showToas('Bienvenido Sr/a:' + res.data.usuario, 'success');

        UturuncoUtils.setSession(UturuncoUtils.UC, JSON.stringify(res.data));
        UturuncoUtils.setToken(res.token);
        UturuncoUtils.setSession("refresh", res.refresh);

        if (res.data.activo) {
          if (this.wsdl.getCantidadTotal() > 0) {
            this.route.navigate(["/user/dashboard/perfil"]);
          } else {
            this.route.navigate(["/"]);
          }
          this.fin.emit(true);

        } else {
          Swal.fire({
            title: 'Ingrese una nueva clave',
            input: 'password',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            showLoaderOnConfirm: true,
            preConfirm: (clave) => {
              return this.wsdlu.doChangePass(res.data.id, this.pass, `${clave}`).then((res: any) => {
                return res;

              }).catch(error => { return error });
            },
            allowOutsideClick: () => !Swal.isLoading()

          }).then((result) => {
            if (result.value.code == 200) {
              this.route.navigate(["/user/dashboard/perfil"]);
              this.fin.emit(true);
            } else {
              UturuncoUtils.showToas("vuelva a intentar", "warning")
            }
          })
        }
      } else {
        Swal.fire('Oops...', res.msg, 'error')
      }

    } catch (error) {
      Swal.fire('Oops...', "Algo salio mal vuelva a intentar ", 'error')
      this.fin.emit(false);
    } finally {
      this.proccess = false;
    }

  }
}
